import { LocalStorageService } from "src/app/utils/localstorage.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class FilePreviewService {
  openFile = new Subject();
  closeFile = new Subject();

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService
  ) {}
}
